import React from "react";
import { useGetHomepageAdvertsQuery } from "../../slices/homepageSlice";
import Loader from "../utilComponents/Loader";

const Adverts = () => {
  const { data: adverts, isLoading, isError } = useGetHomepageAdvertsQuery();

  if (isLoading) {
    return <Loader count={2} rows={2} itemClass="w-[256px] h-[180px]" />;
  }

  if (isError) {
    return (
      <div className="adverts-container flex flex-col h-full justify-center items-center bg-white rounded-md p-4 text-red-600 text-sm border border-red-300">
        Failed to load adverts. Please try again later.
      </div>
    );
  }

  return (
    <div className="adverts-container flex flex-col h-full justify-between space-y-0 bg-white rounded-md cursor-pointer">
      {adverts?.map((advert) => (
        <div key={advert._id} className="advert-item h-[48%]">
          <img
            src={advert.image}
            alt={advert.title}
            className="w-full h-full object-cover rounded-md"
            onClick={() => window.open(advert.url, "_blank")}
          />
        </div>
      ))}
    </div>
  );
};

export default Adverts;
